import React, { useState } from "react";
import { Container, Row } from "reactstrap";

//Import Section Title
import SectionTitle from "../common/section-title";

//Import Pricing
import PricingBox from "./pricing-box";

const Pricing = () => {
  const [isAnnual, setIsAnnual] = useState(false);

  const monthlyPricings = [
    {
      title: "Free",
      price: 0,
      duration: "MONTH",
      features: [
        { title: "Admins", value: "3", isLeft: true },
        { title: "Backlogs", value: "1", isLeft: true },
        { title: "Tickets", value: "Unlimited", isLeft: true },
        { title: "Integrations", value: "3", isLeft: true },
        { title: "Roadmaps", value: "1", isLeft: true },
        { title: "AI requests / mo", value: "100", isLeft: true },
      ],
    },
    {
      title: "STARTER",
      price: 29,
      duration: "MONTH",
      features: [
        { title: "Admins", value: "10", isLeft: true },
        { title: "Backlogs", value: "3", isLeft: true },
        { title: "Tickets", value: "Unlimited", isLeft: true },
        { title: "Integrations", value: "5", isLeft: true },
        { title: "Roadmaps", value: "3", isLeft: true },
        { title: "AI requests / mo", value: "1,000", isLeft: true },
      ],
    },
    {
      title: "BUSINESS",
      price: 79,
      duration: "MONTH",
      isActive: true,
      features: [
        { title: "Admins", value: "Unlimited" },
        { title: "Backlogs", value: "Unlimited" },
        { title: "Tickets", value: "Unlimited" },
        { title: "Integrations", value: "All" },
        { title: "SSO", value: "1 Provider" },
        { title: "AI requests / mo", value: "10,000" },
      ],
    },
    {
      title: "ENTERPRISE",
      price: 149,
      duration: "MONTH",
      features: [
        { title: "Admins", value: "Unlimited" },
        { title: "Everything in Business", value: "Yes" },
        { title: "SSO", value: "Unlimited + Enforce" },
        { title: "Content Translation", value: "Yes" },
        { title: "Priority Support", value: "SLA" },
        { title: "AI requests / mo", value: "Unlimited" },
      ],
    },
  ];

  const annualPricings = monthlyPricings.map((plan) => ({
    ...plan,
    price: plan.price === 0 ? 0 : plan.title === "STARTER" ? 24 : plan.title === "BUSINESS" ? 66 : 125,
    duration: "MONTH",
  }));

  const pricings = isAnnual ? annualPricings : monthlyPricings;

  return (
    <React.Fragment>
      <section className="section pt-5" id="pricing">
        <Container>
          {/* section title */}
          <SectionTitle
            title="Our Pricing"
            desc="Start free and scale as your product grows. All plans include core feedback collection — upgrade for advanced features like roadmaps, integrations, and SSO."
          />

          {/* billing toggle */}
          <div className="text-center mb-4">
            <span className={`me-2 ${!isAnnual ? "fw-bold" : "text-muted"}`}>Monthly</span>
            <div
              className="form-check form-switch d-inline-block"
              style={{ verticalAlign: "middle" }}
            >
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="billingToggle"
                checked={isAnnual}
                onChange={() => setIsAnnual(!isAnnual)}
              />
            </div>
            <span className={`ms-1 ${isAnnual ? "fw-bold" : "text-muted"}`}>
              Annual <span className="badge bg-success ms-1">Save ~17%</span>
            </span>
          </div>

          <Row className="mt-5">
            {/* pricing box */}
            <PricingBox pricings={pricings} />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Pricing;
